(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("systemsApi"));
	else if(typeof define === 'function' && define.amd)
		define("analysisApi", ["systemsApi"], factory);
	else if(typeof exports === 'object')
		exports["analysisApi"] = factory(require("systemsApi"));
	else
		root["analysisApi"] = factory(root["systemsApi"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__670__) => {
return 